import { SocialIcon } from '@change/ds-core-ui';

import { useDeviceMessagingIcon } from 'src/app/shared/hooks/share';

export const DeviceAwareSmsIcon = (): React.ReactNode => {
	const { MessagingIconComponent, variant } = useDeviceMessagingIcon();

	return <SocialIcon className="h-full w-full" icon={<MessagingIconComponent />} variant={variant} />;
};
